export default "__VITE_ASSET__DNZv1RNl__"